export default __webpack_public_path__ + "static/media/dg-title-en.1c2fe5af.webp";